import React from "react";
import { IconColor } from "../interface/ColorInterface";

export const PagesIconForTabSvg: React.FC<IconColor> = ({
  color,
  width,
  height,
  transform,
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3H7C4.7909 3 3 4.7909 3 7V13C3 15.2091 4.7909 17 7 17H12C14.2092 17 16 15.2091 16 13V7C16 4.7909 14.2092 3 12 3Z"
      stroke={color || "#8B8B8B"}
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 7H6.5M12.5 10H6.5M9.5 13H6.5"
      stroke={color || "#8B8B8B"}
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
